import { render, staticRenderFns } from "./FacebookDataDeletion.vue?vue&type=template&id=f6f80f8c&scoped=true"
import script from "./FacebookDataDeletion.vue?vue&type=script&lang=js"
export * from "./FacebookDataDeletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f80f8c",
  null
  
)

export default component.exports